<template>
  <div
    class="courseFooter"
    v-if="!(info.customercourse == 'Y' && courseType == 1003)"
  >
    <div class="purchased" v-if="info.customercourse == 'Y'">
      <div class="content">
        <div class="default" @click="opation('group')">
          <span>加入学习群</span>
        </div>
        <div class="default active" @click="opation('study')">
          <span>继续学习</span>
        </div>
      </div>
    </div>
    <div class="buyBox" v-else>
      <div
        class="collection"
        @click="collectionOpation()"
        v-if="showCollection"
      >
        <i :class="collection == 'Y' ? 'collections' : ''"></i>
        <span>{{ collection == "Y" ? "已想学" : "想学" }}</span>
      </div>
      <div class="content">
        <div
          :class="['default', item.className]"
          v-for="(item, index) in btnList"
          :key="index"
          @click="opation(item.type)"
        >
          <span>{{ item.name }}</span>
          <span v-if="item.value">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["courseType", "info", "dataInfo", "posterskuId", "systemtime"],
  data() {
    return {
      sellingprice: "-1",
      marketprice:"-1",
      collection: "",
      showCollection: true,
      btnList: [],
    };
  },
  watch: {
    ["systemtime"](){
      this.showBtn();
    }
  },
  components: {},
  mounted() {
    this.collection = this.info.collection;
    if (this.courseType == "1003") {
      this.sellingprice = this.info.packageprices[0].sellingprice;
      this.marketprice = this.info.packageprices[0].marketprice;
    } else {
      this.sellingprice = this.info.coursepricedtoes[0].sellingprice;
      this.marketprice = this.info.coursepricedtoes[0].marketprice;
    }
    this.showBtn();
  },
  methods: {
    collectionOpation() {
      console.log(this.util.loginStatus());
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      }
      var obj = {
        referencevalue:
          this.courseType == 1003 ? this.info.packageid : this.info.courseid,
        collectiontype: this.courseType == 1003 ? "1010" : "1000",
      };
      if (this.info && this.info.productid) {
        obj.productid = this.info.productid;
      }
      this.$post("iart-api-crm/api/crm/custservice/createCollection", obj).then(
        (res) => {
          if (this.util.processingData(res)) {
            if (res.code == 1) {
              if (res.data.rtncode == 1) {
                this.collection = this.collection == "Y" ? "N" : "Y";
                this.collection == "Y"
                  ? this.util.toast({ msg: "已收藏想学课程" })
                  : "";
              } else {
                this.util.toast({ msg: res.data.rtnmsg });
              }
            } else {
              this.util.toast({ msg: res.message });
            }
          }
        }
      );
    },
    showBtn() {
      switch (this.courseType - 0) {
        case 1005:
          this.showCollection = false;
          this.btnList = [
            { name: "免费领取", type: "free", className: "active" },
          ];
          break;
        case 1000:
          if(this.info.trysee=='Y'){
this.btnList = [
            { name: "免费试看", type: "trySee", className: "small" },
            { name: "立即购买", type: "oldBuy", className: "active" },
          ];
          }else{
            this.btnList = [
            { name: "立即购买", type: "oldBuy", className: "active" },
          ];
          }
          
          break;
        case 1001:
          this.btnList = [
            {
              name: "原价购买",
              type: "oldBuy",
              className: "",
              value: "¥" + this.sellingprice,
            },
          ];
          if (
            this.systemtime > this.dataInfo.startdate &&
            this.systemtime < this.dataInfo.enddate
          ) {
            if(this.dataInfo.store-this.dataInfo.salecount-this.dataInfo.paycount){
        this.btnList.splice(1,1,{
              name: "优惠购买",
              type: "buy",
              className: "active",
              value: "¥" + this.dataInfo.flashsaleprice,
            })
            }else{
              this.btnList.splice(1,1,{
              name: "已抢完",
              type: "",
              className: "disble",
              value: "¥" + this.dataInfo.flashsaleprice,
            })
            }
           
          } else {
            this.btnList.splice(1,1,{
              name: "提醒我",
              type: "remind",
              className: "active",
              value: "",
            });
          }
          break;
        case 1002:
          this.btnList = [
            {
              name: "原价购买",
              type: "oldBuy",
              className: "small",
              value: "¥" + this.dataInfo.sellingprice,
            },
            {
              name: this.dataInfo.groupStatus == 1001 ? "拼团详情" : "立即开团",
              type: "groupBuy",
              className: "active",
              value:
                this.dataInfo.groupStatus != 1001
                  ? "¥" + this.dataInfo.groupprice
                  : "",
            },
          ];
          break;
        case 1003:
          this.btnList = [
            {
              name: "优惠购买",
              type: "oldBuy",
              className: "active",
              value: "¥" + this.sellingprice,
            },
          ];
          break;
        default:
          break;
      }
    },
    opation(type) {
      switch (type) {
        case "group":
          var obj = {
            this: this,
            loginStatus: false,
            url: "/h5/course/group",
            query: {
              courseType: this.courseType == 1003 ? 1003 : 1000,
              courseid: this.info.courseid,
            },
          };
          this.util.goto(obj);
          break;
        case "groupBuy":
          // if (this.dataInfo.groupStatus == 1001) {
          //   var obj = {
          //     this: this,
          //     loginStatus: true,
          //     url: "/h5/course/groupDetail",
          //     query: {
          //       ordergroupheadid: this.dataInfo.ordergroupheadid,
          //     },
          //   };
          //   this.util.goto(obj);
          // } else {
            this.buy();
        //  }
          break;
        case "buy":
          this.buy();
          break;
        case "oldBuy":
          this.buy("oldBuy");
          break;
        case "trySee":
          var obj = {};
          obj.courseid = this.info.courseid;
          obj.type = 1;
          this.$router.push({
            path: "/h5/course/coursePlay",
            query: obj,
          });
          break;
        case "study":
          var obj = {};
          obj.courseid = this.info.courseid;
          obj.item = JSON.stringify({
            type: 2,
            lessonid: this.info.newlessonid-0 ? this.info.newlessonid :this.info.chapters[0].lessons[0].lessonid,
          });
          this.$router.push({
            path: "/h5/course/coursePlay",
            query: obj,
          });
          break;
        case "remind":
          this.remind();
          break;
        case "free":
          this.free();
          break;
        default:
          break;
      }
    },
    remind() {
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
      } else {
        var dataInfo = this.dataInfo;
        if (dataInfo.subscribeStatus != 1004) {
          var obj = {
            messagetype: 3000,
            targettype: 1005,
            message: this.dataInfo.title,
            businessid: this.dataInfo.flashsaleid,
            informationtype: 1001,
          };
          this.$post(
            "iart-api-crm/api/crm/custservice/createBySubscribeMessage",
            obj
          ).then((res) => {
            if (res.code == 1) {
              dataInfo.subscribeStatus != 1004
                ? (dataInfo.subscribeStatus = 1004)
                : "";
              this.util.toast({ msg: "已订阅该提醒" });
            } else {
              this.util.toast({ msg: res.message });
            }
          });
        } else {
          this.util.toast({ msg: "已订阅该提醒" });
        }
      }
    },
    buy(type) {
      var info = this.info;
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      }
      if (info.customercourse != "Y") {
        if (this.sellingprice > 0) {
          this.$router.push({
            path: "/h5/common/order",
            query: {
              coursetype: type? this.courseType == 1003? 1003 : 1000: this.courseType,
              courseid:this.courseType == 1002? this.dataInfo.promotiongroupdkuid: this.courseType == 1001? this.dataInfo.flashsaleskuid: "",
              ordertype: this.courseType == 1003 ? 1010 : 1000,
              productid:this.courseType == 1003? this.info.packageprices[0].productid: this.info.coursepricedtoes[0].productid,
            },
          });
        } else {
          this.freeObj = {
            coursetype: this.courseType,
            courseid:
              this.courseType == 1002
                ? this.dataInfo.promotiongroupdkuid
                : this.courseType == 1001
                ? this.dataInfo.flashsaleskuid
                : "",
            ordertype: this.courseType == 1003 ? 1010 : 1000,
            buyNum: 1,
            productid:this.courseType == 1003? this.info.packageprices[0].productid: this.info.coursepricedtoes[0].productid,
          };
          this.freePay();
        }
      }
    },
    //免费订单类型
    free() {
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      }
      var obj = {
        posterskuid: this.posterskuId,
      };
      this.util.showLoading();
      this.$post(
        "/iart-api-crm/api/crm/platformposter/receiveFreeCourse",
        obj
      ).then((res) => {
        this.util.hideLoading();
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              this.$emit("courseFooterCallback", { type: "reload" });
            } else {
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
    //正常课程 价格为0
    freePay() {
      var freeObj = this.freeObj;
      var obj = {
        ordertype: freeObj.ordertype,
        details: [
          {
            productid: freeObj.productid,
            quantity: freeObj.buyNum ? freeObj.buyNum : 1,
          },
        ],
        payment: { paymentmode: 1007, subpaymode: 1003 },
      };

      if (freeObj.ordertype == 1004) {
        obj.details[0].ticket = { tickettype: freeObj.tickettype };
      }
      this.util.showLoading();
      this.$post("iart-api-oaf/api/oaf/customer/order", obj).then((res) => {
        this.util.hideLoading();
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              this.$emit("courseFooterCallback", { type: "reload" });
            } else {
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.courseFooter {
  background: #fff;
  padding: 14px 24px;
  width: 100%;
  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .default {
    flex: 1;
    height: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(247, 247, 247, 1);
    border-radius: 3px;
    overflow: hidden;
    color: rgba(53, 54, 60, 1);
    span:last-child {
      font-size: 10px;
      line-height: 14px;
    }
    span:first-child {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
    }
  }
  .default:not(:last-child) {
    margin-right: 16px;
  }
  .small{
    width: 34%;
    flex: none;
  }
  .active {
    background: rgba(201, 55, 61, 1);
    color: rgba(255, 255, 255, 1);
  }
  .disble{
    background: #CECECE;
    color: rgba(255, 255, 255, 1);
  }
  .buyBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    .collection {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      width: 40px;
      i {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url(../../../../assets/img/h5/collection.png) no-repeat;
        background-size: 24px 24px;
      }
      i.collections {
        background: url(../../../../assets/img/h5/collections.png) no-repeat;
        background-size: 24px 24px;
      }
      span {
        font-size: 12px;
        line-height: 17px;
        color: rgba(174, 175, 177, 1);
        margin-top: 4px;
      }
    }
    .content {
      flex: 1;
      overflow: hidden;
    }
  }
}
</style>